import { createFileRoute } from "@tanstack/react-router";
import { ReturnDetailPage } from "@/components/inventory/ReturnDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/returns_/$id")({
  component: ReturnDetailRoute,
});

function ReturnDetailRoute() {
  const { id } = Route.useParams();
  return <ReturnDetailPage returnId={id} />;
}
